import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Map routes to human-friendly titles
const ROUTE_TITLES = {
  '/': 'Home',
  '/login': 'Login',
  '/forcelogin': 'Force Login',
  '/session-expired': 'Session Expired',
  '/explorer': 'Menu',
  '/dashboard': 'Dashboard',
  '/advance-report': 'Advance Report',
  '/ai-report-display': 'AI Report',
};

export default function useRouteTitle(base = 'RMP') {
  const { pathname } = useLocation();

  useEffect(() => {
    const name = ROUTE_TITLES[pathname] || pathname.split('/').filter(Boolean).join(' - ') || base;
    document.title = `${name}`;
  }, [pathname, base]);
}
